import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import helpers from 'helpers';
import { call, put } from 'redux-saga/effects';

import { authHttpClient, httpClient, rikHttpClient } from 'services/httpClient';

import { IApplicationState } from 'store/rootReducers';

import { authActions } from '../index';

function* refreshToken({ payload }: PayloadAction<IApplicationState>) {
  try {
    if (!payload) {
      return;
    }
    const { authorization } = payload.auth;

    if (authorization.accessToken) {
      authHttpClient.defaults.headers.common.Authorization = `Bearer ${authorization.accessToken}`;

      const { data: accessToken }: AxiosResponse<string> = yield call(
        authHttpClient.get,
        `api/users/refresh`,
      );

      httpClient.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
      rikHttpClient.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

      yield put(
        authActions.setToken({
          accessToken,
        }),
      );
    }
  } catch (err: any) {
    helpers.errorHandling(err);
  }
}

export default refreshToken;
